import { EducationalMaterial } from '@dreryk/egabinet-knowledge-base-frontend-api';
import { EducationalMaterialsSendToPatientCommand, VisitPatient } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { VisitId } from '~libs.shared.visit';

import { educationalMaterialsTranslationKeys as t } from '../translations';

import {
   EducationalMaterialShareFormBean,
   EducationalMaterialShareFormSubmitHandler,
} from './EducationalMaterialShareForm.types';

type EducationalMaterialShareEventInterceptorProps = Readonly<{
   children: JSX.Element;
   visitId: VisitId;
   patientEmail: VisitPatient['emailAddress'];
   educationalMaterials: EducationalMaterial[];
   onEducationalMaterialShareFormSubmit: EducationalMaterialShareFormSubmitHandler;
   onEducationalMaterialsShareSuccess?: VoidFunction;
}>;

export const EducationalMaterialShareEventInterceptor = (
   props: EducationalMaterialShareEventInterceptorProps
): JSX.Element => {
   const { executeAsync: sendEducationalMaterialsToPatient } = useCqrsCommand<null, EducationalMaterialShareFormBean>(
      (parameters) => {
         const command = new EducationalMaterialsSendToPatientCommand();
         command.visitId = props.visitId;
         command.patientEmailAddress = parameters.emailAddress!;
         command.educationalMaterialIds = props.educationalMaterials.map((item) => item.id);

         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(t.share.educationalMaterialsSentToPatient);
            props.onEducationalMaterialsShareSuccess?.();
         },
      }
   );

   return (
      <ActionEventInterceptor
         action={props.onEducationalMaterialShareFormSubmit(sendEducationalMaterialsToPatient)}
         blockingOperation={t.share.sendingEducationalMaterialsToPatient}
      >
         {props.children}
      </ActionEventInterceptor>
   );
};
